import { forwardRef, useEffect } from "react";
import {
  Button,
  TextField,
  Dialog,
  DialogContent,
  Grid,
  Typography,
} from "@mui/material";
import Slide from "@mui/material/Slide";
import { useDispatch, useSelector } from "react-redux";
import { Controller, useForm } from "react-hook-form";
import { DesktopDatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";
import {
  setDialog,
  resetForm,
  LeaveUser,
} from "../../../app/slices/leaveUserSlice";

const Transition = forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const LeaveForm = () => {
  const _Leave = useSelector((state) => state.leaveUser.leave);
  const _SearchBody = useSelector((state) => state.leaveUser.searchBody);
  const dispatch = useDispatch();

  const isAdd = _Leave.form.id ? false : true;
  const { control, handleSubmit, setValue, watch } = useForm({
    defaultValues: _Leave.form,
  });

  const startDate = watch("start_date");
  const totalDays = watch("total_days");

  // The API only takes a start date and a day count, so the end date is shown
  // as a hint to make the range unambiguous for the rep.
  const endDate =
    startDate && Number(totalDays) > 0
      ? dayjs(startDate)
          .add(Number(totalDays) - 1, "day")
          .format("YYYY-MM-DD")
      : null;

  const onSubmit = (data) => {
    const payload = {
      start_date: dayjs(data.start_date).format("YYYY-MM-DD"),
      total_days: Number(data.total_days),
      reason: data.reason,
    };
    if (isAdd) {
      dispatch(LeaveUser.create(payload, _SearchBody));
    } else {
      dispatch(LeaveUser.update(data.id, payload, _SearchBody));
    }
  };

  useEffect(() => {
    return () => {
      dispatch(resetForm());
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handlDialog = () => {
    dispatch(setDialog());
  };

  return (
    <Dialog
      open={_Leave.dialog}
      TransitionComponent={Transition}
      keepMounted
      fullWidth={true}
      dir="rtl"
      onClose={() => {
        handlDialog();
      }}
      aria-describedby="alert-dialog-slide-description"
    >
      <DialogContent>
        <Typography
          mb={3}
          variant="h4"
          color={"purple"}
          gutterBottom
          component="div"
        >
          {isAdd ? "أضافة طلب اجازة" : "تعديل طلب الاجازة"}
        </Typography>
        <form onSubmit={handleSubmit(onSubmit)}>
          <Grid container spacing={2}>
            <Grid item xs={12} md={6}>
              <Controller
                name="start_date"
                control={control}
                render={({ field }) => (
                  <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <DesktopDatePicker
                      inputFormat="YYYY-MM-DD"
                      label="تاريخ بداية الاجازة"
                      value={field.value}
                      onChange={(e) => {
                        setValue("start_date", dayjs(e).format("YYYY-MM-DD"));
                      }}
                      renderInput={(params) => (
                        <TextField
                          required
                          size="small"
                          fullWidth
                          {...params}
                          inputProps={{
                            ...params.inputProps,
                            placeholder: "يوم/شهر/سنة",
                          }}
                        />
                      )}
                    />
                  </LocalizationProvider>
                )}
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <Controller
                name="total_days"
                control={control}
                render={({ field }) => (
                  <TextField
                    required
                    size="small"
                    type="number"
                    label="عدد الايام"
                    fullWidth
                    inputProps={{ min: 1 }}
                    helperText={endDate ? `اخر يوم: ${endDate}` : null}
                    {...field}
                  />
                )}
              />
            </Grid>
            <Grid item xs={12} md={12}>
              <Controller
                name="reason"
                control={control}
                render={({ field }) => (
                  <TextField
                    required
                    size="small"
                    label="سبب الاجازة"
                    multiline
                    rows={3}
                    fullWidth
                    {...field}
                  />
                )}
              />
            </Grid>
            <Grid item xs={12} md={12}>
              <Button type="submit" variant="contained" color="primary">
                حفظ
              </Button>
            </Grid>
          </Grid>
        </form>
      </DialogContent>
    </Dialog>
  );
};

export default LeaveForm;
